import { ITypography } from "@swiggy-private/dls-web-common/dist/components/types";

export const DLS_TEXT_VARIANTS: Record<string, keyof ITypography> = {
    HEADER_H2_BLACK: "V2.heading2.neutral.black",
    HEADER_H1_BLACK: "V2.heading1.neutral.black",
    SUBHEADING_BLACK: "V2.subheading1.neutral.black",
    BODY_B1_REG: "V2.body1.neutral.regular",
    BODY_B1_BOLD: "V2.body1.neutral.bold",
    BODY_B2_MED: "V2.body2.neutral.medium",
    SUBHEADER_S1_REG: "V2.subheading1.neutral.medium",
    V2_HERO_NEUTRAL_BLACK: "V2.hero.neutral.black",
    OVERLINE_NEUTRAL_BOLD_SPACED: "V2.overline.neutral.bold_spaced",
    BODY_B2_BOLD: "V2.body2.neutral.bold",
    OVERLINE_NEUTRAL_MEDIUM: "V2.overline.neutral.medium",
    BODY_B3_MED: "V2.body3.neutral.medium",
    BODY_B3_REG: "V2.body3.neutral.regular",
    HEADING_H2_BOLD: "V2.heading2.neutral.bold",
    BODY_B3_BOLD: "V2.body3.neutral.bold",
};
